import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Container, TextField, List, ListItem, ListItemText, Button, Typography, Box, Pagination, CircularProgress } from '@mui/material';

const WebsiteList = () => {
    const [websites, setWebsites] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedWebsite, setSelectedWebsite] = useState(null);
    const [timestamps, setTimestamps] = useState([]);
    const [timestampSearchTerm, setTimestampSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        fetchWebsites(currentPage, searchTerm);
    }, [currentPage, searchTerm]);

    const fetchWebsites = async (page, search) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://pixel-full-stack.onrender.com/api/get-unique-website-names/`, {
                params: {
                    page: page,
                    search: search
                }
            });
            setWebsites(response.data.results);
            setTotalPages(response.data.total_pages);
        } catch (error) {
            console.error('Error fetching websites:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleWebsiteClick = async (websiteName) => {
        setSelectedWebsite(websiteName);
        setLoading(true);
        try {
            const response = await axios.get(`https://pixel-full-stack.onrender.com/api/get-timestamps/`, {
                params: {
                    website_name: websiteName
                }
            });
            setTimestamps(response.data.timestamps);
        } catch (error) {
            console.error('Error fetching timestamps:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleTimestampSearchChange = (event) => {
        setTimestampSearchTerm(event.target.value);
    };

    const handleTimestampClick = (timestamp) => {
        history.push(`/website/${selectedWebsite}/timestamp/${timestamp}`);
    };

    const filteredTimestamps = timestamps.filter(timestamp =>
        timestamp.toLowerCase().includes(timestampSearchTerm.toLowerCase())
    );

    return (
        <Container>
            <Typography variant="h3" gutterBottom>Website Names</Typography>
            <TextField
                label="Search website (ex: google.com)"
                variant="outlined"
                fullWidth
                margin="dense"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ mb: 2 }}
            />
            {loading ? (
                <Box display="flex" justifyContent="center" my={2}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    {websites.length === 0 ? (
                        <Box display="flex" flexDirection="column" alignItems="center" my={4}>
                            <Typography variant="h5" gutterBottom>Oops! No results found 😢</Typography>
                        </Box>
                    ) : (
                        <>
                            <List>
                                {websites.map((website, index) => (
                                    <ListItem button style={
                                        selectedWebsite === website.website_name ? { backgroundColor: '#f0f0f0' } : {}
                                    } key={index} onClick={() => handleWebsiteClick(website.website_name)}>
                                        <ListItemText primary={website.website_name} />
                                    </ListItem>
                                ))}
                            </List>
                            <Box display="flex" justifyContent="center" my={2}>
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    color="primary"
                                />
                            </Box>
                        </>
                    )}
                    {selectedWebsite && (
                        <Box mt={4}>
                            <Typography variant="h5" gutterBottom>Timestamps for {selectedWebsite}</Typography>
                            <TextField
                                label="Search timestamp (ex: 2021-09-01T00:00:00)"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={timestampSearchTerm}
                                onChange={handleTimestampSearchChange}
                                sx={{ mb: 2 }}
                            />
                            <Box display="flex" flexWrap="wrap" gap={1}>
                                {filteredTimestamps.map((timestamp, index) => (
                                    <Button key={index} variant="contained" color="primary" onClick={() => handleTimestampClick(timestamp)}>
                                        {timestamp}
                                    </Button>
                                ))}
                            </Box>
                        </Box>
                    )}
                </>
            )}
        </Container>
    );
};

export default WebsiteList;